import { Component, OnInit } from '@angular/core';


@Component({
  moduleId: module.id,
  templateUrl: 'login.component.html',
  styleUrls: ['../app.component.css'],
})

export class LoginComponent implements OnInit {

  ngOnInit() {}

}




// WEBPACK FOOTER //
// H:/Proyectos Galeras Indie/Vinta/vinta Tinka/VintaWebClient/src/app/Login/login.component.ts